import { render, staticRenderFns } from "./Commonfooter.vue?vue&type=template&id=7f3fad7a"
import script from "./Commonfooter.vue?vue&type=script&lang=js"
export * from "./Commonfooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports